import { render, staticRenderFns } from "./AdminContractorsTabContainerNew.vue?vue&type=template&id=9e474cde&scoped=true"
import script from "./AdminContractorsTabContainerNew.vue?vue&type=script&lang=ts"
export * from "./AdminContractorsTabContainerNew.vue?vue&type=script&lang=ts"
import style0 from "./AdminContractorsTabContainerNew.vue?vue&type=style&index=0&id=9e474cde&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e474cde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e474cde')) {
      api.createRecord('9e474cde', component.options)
    } else {
      api.reload('9e474cde', component.options)
    }
    module.hot.accept("./AdminContractorsTabContainerNew.vue?vue&type=template&id=9e474cde&scoped=true", function () {
      api.rerender('9e474cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companyContractors/AdminContractorsTabContainerNew.vue"
export default component.exports